import { Flex, Text } from "@chakra-ui/layout";
import { PieChart, Pie, Cell } from "recharts";
import colors from "core/resources/theme/colors";
import CardDefault from "components/Cards/CardDefault";
import { Skeleton } from "@chakra-ui/skeleton";

interface GraficoClientesProps {
  valorInadimplentes: number;
  valorEmdia: number;
  valorPendente: number;
  loading: boolean;
}

export default function GraficoClientes({
  valorPendente,
  valorInadimplentes,
  valorEmdia,
  loading,
}: GraficoClientesProps) {
  const size = 110;
  return (
    <CardDefault
      flexDir="row"
      justifyContent="center"
      alignItems="center"
      h="100%"
      gap={4}
    >
      {!loading ? (
        <PieChart
          style={{
            background: colors.blue100,
            margin: "auto",
            borderRadius: "50%",
          }}
          width={size}
          height={size}
        >
          <Pie
            dataKey="value"
            data={[
              { name: "Em Dia", value: valorEmdia },
              { name: "Pendente", value: valorPendente },
              { name: "Inadimplentes", value: valorInadimplentes },
            ]}
            innerRadius={10}
            outerRadius={size / 2}
            labelLine={false}
            label={renderCustomizedLabel}
          >
            <Cell
              key={`cell-0`}
              fill={colors.green}
              display={valorEmdia ? undefined : "none"}
            />

            <Cell
              key={`cell-1`}
              fill={colors.yellow}
              display={valorPendente ? undefined : "none"}
            />

            <Cell
              key={`cell-2`}
              fill={colors.red}
              display={valorInadimplentes ? undefined : "none"}
            />
          </Pie>
        </PieChart>
      ) : (
        <Skeleton w="90px" h="90px" rounded="full" />
      )}

      <Flex flexDir="column" gap={3} margin="auto">
        <Flex gap={2}>
          <Flex
            borderTopRadius="10px"
            borderBottomRadius="10px"
            bg={colors.green}
            w="5px"
          />
          {!loading ? <Text fontSize="13px">Em Dia</Text> : null}
          {loading ? <Skeleton w="80px" h="20px" rounded="full" /> : null}
        </Flex>

        <Flex gap={2}>
          <Flex
            borderTopRadius="10px"
            borderBottomRadius="10px"
            bg={colors.yellow}
            w="5px"
          />
          {!loading ? <Text fontSize="13px">Pendente</Text> : null}
          {loading ? <Skeleton w="80px" h="20px" rounded="full" /> : null}
        </Flex>

        <Flex gap={2}>
          <Flex
            borderTopRadius="10px"
            borderBottomRadius="10px"
            bg={colors.red}
            w="5px"
          />
          {!loading ? <Text fontSize="13px">Inadimplentes</Text> : null}
          {loading ? <Skeleton w="80px" h="20px" rounded="full" /> : null}
        </Flex>
      </Flex>
    </CardDefault>
  );
}

const RADIAN = Math.PI / 180;
const renderCustomizedLabel = ({
  cx,
  cy,
  midAngle,
  innerRadius,
  outerRadius,
  percent,
}: any) => {
  const radius = innerRadius + (outerRadius - innerRadius) * 0.5;
  const x = cx + radius * Math.cos(-midAngle * RADIAN);
  const y = cy + radius * Math.sin(-midAngle * RADIAN);

  if (!percent) {
    return null;
  }

  return (
    <g>
      <circle
        x={x}
        y={y}
        cx={x}
        cy={y}
        r="11"
        stroke="#ffffff"
        fill="#ffffff"
      />
      <text
        x={x}
        y={y}
        fontWeight="500"
        fill="black"
        textAnchor="middle"
        dominantBaseline="central"
        fontSize="9px"
      >
        {`${(percent * 100).toFixed(0)}%`}
      </text>
    </g>
  );
};
